import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledMemberPanel = styled.div`
  margin-top: ${toRem(52)};

  @media ${baseVariables.mediaQuery.lg} {
    margin-top: ${toRem(100)};
  }

  .listCollection {
    list-style: none;

    .listClassName {
      font-size: ${toRem(16)};
      line-height: ${toRem(19)};

      &:hover {
        border-bottom-width: ${toRem(1)};
        padding-bottom: ${toRem(1.5)};
      }
    }
  }

  .signout {
    color: ${baseVariables.color['alert40']};
    font-size: ${toRem(12)};
    letter-spacing: ${toRem(1.15)};
    border-bottom: none;
    line-height: ${toRem(19)};
    background: none;
    &:focus {
      outline: 5px auto -webkit-focus-ring-color;
    }

    .signoutLabel :hover {
      border-bottom: ${toRem(1)} solid ${baseVariables.color['alert40']};
    }
  }

  .separator {
    width: 100%;
    margin-block: inherit;
    margin-top: ${toRem(24)};

    @media ${baseVariables.mediaQuery.lg} {
      margin-top: ${toRem(28)};
    }
  }

  .separator {
    color: ${baseVariables.color['neutral30']};
    border-bottom: 0;
  }
`;
